/**
 * User: Rob Richard
 * Date: 5/21/14
 * Time: 5:57 PM
 */

'use strict';

var _ = require('underscore');
var SoaCollection = require('bunsen/collections/SoaCollection.js');
var Invoice = require('bunsen/models/ecomm/Invoice.js');
var getInvoiceByFn = function (fn) {
    return this.find(function (invoice) {
        return invoice[fn]() && invoice.get("status") !== Invoice.STATUS_CANCELED;
    });
};

module.exports = SoaCollection.extend({
    model: Invoice,
    getDealerInvoice: _.partial(getInvoiceByFn, 'isDealerInvoice'),
    getBuyerInvoice: _.partial(getInvoiceByFn, 'isBuyerInvoice'),
    getShipperInvoice: _.partial(getInvoiceByFn, 'isShipperInvoice')
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/ecomm/Invoices.js
// module id = 160
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56